import { render, staticRenderFns } from "./custom-form-service.vue?vue&type=template&id=09a3e302&scoped=true&"
import script from "./custom-form-service.vue?vue&type=script&lang=js&"
export * from "./custom-form-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3e302",
  null
  
)

export default component.exports